import { isNil } from 'lodash';

import { defaultIVROptionEditorOutput } from '../default-ivr-option-editor-output';
import { IVROptionEditorOutput } from '../ivr-option-editor-output';
import { IVROptionEditorFormType } from '../ivr-option-form-type';

export const formToIVROptionEditorOutput = (
  formType: IVROptionEditorFormType | undefined | null,
): IVROptionEditorOutput => {
  if (isNil(formType)) {
    return defaultIVROptionEditorOutput;
  }

  return {
    displayName: (formType.displayName ?? '').trim(),
    description: (formType.description ?? '').trim(),
    keyPresses: formType.keyPresses ?? [],
    phrases: formType.phrases ?? [],
    commands: formType.commands ?? { commands: [] },
  };
};
